module.exports = __webpack_public_path__ + "static/media/skintype_t.68cfd50f.svg";